import React, { Fragment, useState } from "react";
import { useParams } from "react-router-dom";
import { jobs } from "../../api/jobsData";
import NavbarS4 from "../../components/NavbarS4/NavbarS4";
import Logo from '../../images/logo2.png'
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import SEO from "../../components/Seo";
import PageTitle from "../../components/pagetitle/PageTitle";
import ScrollTextAnimation from "../../components/ScrollTextAnimation/ScrollTextAnimation";
import ApplyForm from "../../components/applyform/ApplyForm";

export default function CareerDetail() {
  const { id } = useParams();
  const job = jobs.find((item) => item.id === id);
  const [openForm, setOpenForm] = useState(false);

  if (!job) {
    return <div className="career-notfound">Job Not Found</div>;
  }

  return (
    <Fragment>
      <SEO
        title={`${job.title} | Careers at LuxRock Realty`}
        description={`Apply for the ${job.title} position at LuxRock Realty in ${job.location}. Join our growing real estate team and build your career with us.`}
        keywords={`LuxRock Realty careers, ${job.title} job, real estate jobs Ahmedabad, property consultant career, real estate company hiring`}
      />
      <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
        col2={'col-lg-2 col-md-4 col-6'}
        col3={'col-lg-7 col-md-1 col-1'}
        col4={'col-lg-3 col-md-4 col-2'} />
      <PageTitle
        pageTitle={"Career Opportunity"}
        pagesub={job.title}
      />
      <ScrollTextAnimation />

      <div className="career-detail-page">

        {/* HERO */}
        <section className="job-hero">
          <div className="container hero-grid">

            <div className="hero-left">
              <span className="job-tag">Career Opportunity</span>

              <h1>{job.title}</h1>

              <p className="job-description">
                {job.description}
              </p>

              <div className="hero-buttons">
                <button
                  className="apply-btn"
                  onClick={() => setOpenForm(true)}
                >
                  Apply Now
                </button>
                {openForm && (
                  <div className="apply-modal">

                    <div
                      className="modal-overlay"
                      onClick={() => setOpenForm(false)}
                    ></div>

                    <div className="modal-content">

                      <button
                        className="close-btn"
                        onClick={() => setOpenForm(false)}
                      >
                        ✕
                      </button>

                      <ApplyForm jobTitle={job.title} />

                    </div>

                  </div>
                )}                <button className="outline-btn">Share Job</button>
              </div>
            </div>

            <div className="hero-right">

              <div className="job-overview-card">
                <h3>Job Overview</h3>

                <div className="overview-item">
                  <span>📍 Location</span>
                  <p>{job.location}</p>
                </div>

                <div className="overview-item">
                  <span>💼 Job Type</span>
                  <p>{job.type}</p>
                </div>

                <div className="overview-item">
                  <span>💰 Salary</span>
                  <p>{job.salary}</p>
                </div>

                <div className="overview-item">
                  <span>📅 Experience</span>
                  <p>{job.experience}</p>
                </div>

              </div>

            </div>

          </div>
        </section>

        {/* RESPONSIBILITIES */}
        <section className="job-section container">

          <div className="content-grid">

            <div className="job-content">

              <h2>Key Responsibilities</h2>

              <ul className="job-list">
                {job.responsibilities.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>

              <h2>Required Skills</h2>

              <div className="skills-grid">
                {job.skills.map((skill, i) => (
                  <span key={i} className="skill-badge">
                    {skill}
                  </span>
                ))}
              </div>

            </div>

            {/* SIDEBAR */}
            <aside className="job-sidebar">

              <div className="apply-card">

                <h3>Apply for this position</h3>

                <p>
                  Join our growing team and build a successful career in
                  real estate.
                </p>

                <button
                  className="apply-btn full"
                  onClick={() => setOpenForm(true)}
                >
                  Apply Now
                </button>

              </div>

              <div className="benefits-card">

                <h3>Benefits</h3>

                <ul>
                  <li>Competitive salary</li>
                  <li>Performance incentives</li>
                  <li>Career growth opportunities</li>
                  <li>Friendly work environment</li>
                </ul>

              </div>

            </aside>

          </div>

        </section>

      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
}